import React from 'react';

import ListaPerfiles from './ListaPerfiles.jsx';
import PermisosEspacialesLista from './PermisosEspacialesLista.jsx';
import ModoExclusivoLista from './ModoExclusivoLista.jsx';
import AccesoSimultaneoLista from './AccesoSimultaneoLista.jsx';
import UltimoLogin from './UltimoLogin.jsx';

const UsuarioSeguridadDetalle = (props) => {
    let oGrupos = props.gruposWindows.map(function (grupo) {
        return <input className="form-control default-input  bottom-separator-xs input-disabled-windows-groups" type="text" value={grupo.nombre} disabled />
    });

    return (
        <div className="user-view">
            <ListaPerfiles perfiles={props.perfiles} />

            {props.configuracionPwType.VincularGrupoWindows == true && props.configuracionPwType.TipoSeguridad == 'AD'
                 && props.gruposWindows && props.gruposWindows.length > 0 &&
                (<div className="">
                    <div className="row">
                        <div className="col-xs-12">
                            <h3 className="divisor-section">Grupos de Windows</h3>
                        </div>
                    </div>
                    <div className="row">
                        <div className=" col-xs-4">
                            {oGrupos}
                        </div>
                    </div>
                </div>)}

            {props.permisosParaMostrar.length > 0 &&
                <PermisosEspacialesLista permisosParaMostrar={props.permisosParaMostrar} />}

            <div id="footer" className="row">
                <div className="col-md-6 col-xs-12 right-separator">
                    <h3 className="divisor-section">Configuración de acceso</h3>

                    {props.usuario && props.usuario.Cambio_Clave ?
                        (<label className="label-primary bottom-separator-xs">Debe cambiar la clave en el próximo acceso</label>) :
                        null}

                    <ModoExclusivoLista modoExclusivo={props.modoExclusivo} />
                    {props.accesosSimultaneos.length > 0 &&
                        <AccesoSimultaneoLista accesosSimultaneos={props.accesosSimultaneos} usuario={props.usuario} />}
                </div>
                <div className="col-md-6 col-xs-12">
                    <UltimoLogin ultimoIngreso={props.ultimoIngreso} />
                </div>
            </div>
        </div>
    );
}

export default UsuarioSeguridadDetalle;